module.exports = __webpack_public_path__ + "img/pagebanner-info.1f421a24.jpg";